"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _ChipBase = _interopRequireDefault(require("./ChipBase"));

var _helperComponents = require("./helperComponents");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _excluded = ["avatar", "children", "size", "isSelected", "icon", "iconPosition", "onClick", "onDismiss", "colorScheme", "dismissButtonRef", "dismissButtonAltText", "backgroundColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ChipWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var avatar = props.avatar,
      children = props.children,
      _props$size = props.size,
      size = _props$size === void 0 ? _interfaces.ChipSize.Default : _props$size,
      isSelected = props.isSelected,
      icon = props.icon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? _interfaces.ChipIconPosition.Leading : _props$iconPosition,
      onClick = props.onClick,
      onDismiss = props.onDismiss,
      _props$colorScheme = props.colorScheme,
      colorScheme = _props$colorScheme === void 0 ? _interfaces.ChipColorScheme.Default : _props$colorScheme,
      dismissButtonRef = props.dismissButtonRef,
      _props$dismissButtonA = props.dismissButtonAltText,
      dismissButtonAltText = _props$dismissButtonA === void 0 ? 'Remove' : _props$dismissButtonA,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? _interfaces.ChipBackgroundColor.Default : _props$backgroundColo,
      htmlProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var chipBaseProps = {
    avatar: avatar,
    children: children,
    size: size,
    icon: icon,
    iconPosition: iconPosition,
    onClick: onClick,
    onDismiss: onDismiss,
    colorScheme: colorScheme,
    dismissButtonRef: dismissButtonRef,
    dismissButtonAltText: dismissButtonAltText,
    backgroundColor: backgroundColor
  };
  var baseContent = (0, _core.jsx)(_ChipBase.default, chipBaseProps);
  var baseContainerProps = {
    colorScheme: colorScheme
  };
  return onClick && !avatar ? (0, _core.jsx)(_helperComponents.ChipClickableContainer, (0, _extends2.default)({
    ref: ref,
    isSelected: isSelected,
    "aria-pressed": isSelected,
    onClick: onClick
  }, baseContainerProps, htmlProps), baseContent) : (0, _core.jsx)(_helperComponents.ChipStaticContainer, (0, _extends2.default)({
    ref: ref,
    backgroundColor: backgroundColor
  }, baseContainerProps, htmlProps), baseContent);
});
var ChipWithDocs = (0, _stencilReactDesc.describe)(ChipWithoutDocs).description('Compact element that represent an input, attribute, or action');
ChipWithDocs.defaultProps = {
  size: _interfaces.ChipSize.Default,
  iconPosition: _interfaces.ChipIconPosition.Leading,
  colorScheme: _interfaces.ChipColorScheme.Default,
  backgroundColor: _interfaces.ChipBackgroundColor.Default,
  dismissButtonAltText: 'Remove'
};
ChipWithDocs.propTypes = {
  avatar: _stencilReactDesc.PropTypes.shape({
    username: _stencilReactDesc.PropTypes.string.isRequired,
    fullName: _stencilReactDesc.PropTypes.string,
    isUsernameClickable: _stencilReactDesc.PropTypes.bool,
    newTabHiddenText: _stencilReactDesc.PropTypes.string
  }).description('Show avatar as chip content.'),
  children: _stencilReactDesc.PropTypes.node.description('Text to display in the chip.'),
  size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipSize)).description('Specifies what size of the chip should be used.'),
  isSelected: _stencilReactDesc.PropTypes.bool.description("\n  'Determines whether the chip is currently selected by showing a visual indication.'\n  "),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon on the leading or trailing side of the chip.'),
  iconPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipIconPosition)).description('Determines on which side the icon would be placed.'),
  onClick: _stencilReactDesc.PropTypes.func.description('Makes the chip to be clickable. This function will then be called when the user clicks the chip.').format('() => void'),
  onDismiss: _stencilReactDesc.PropTypes.func.description('Makes the chip to be dismissible. This function will then be  called when the user clicks the X button (dismiss button) in the chip. The argument allows to distinguish whether the action was triggered by mouse or keyboard').format("(triggeredBy: 'keyboard' | 'mouse' ) => void"),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  dismissButtonRef: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.func, _stencilReactDesc.PropTypes.shape({
    current: _stencilReactDesc.PropTypes.any
  })]).description('Reference to attach to the dismiss button.'),
  dismissButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text used for the dismiss button in the chip.'),
  backgroundColor: _stencilReactDesc.PropTypes.string.description('Sets the background color for the static chip. Does not affect the text color, so only colors with enough contrast should be used.')
};
var Chip = (0, _utils.withTestAttributes)({
  component: 'StencilChip'
})(ChipWithDocs);
Chip.displayName = 'Chip';
var _default = Chip;
exports.default = _default;